import React from 'react';
import * as R from 'ramda';
import { isPast, parseISO } from 'date-fns';
import { isLessThan, isNumber } from 'utils/helpers/formValidations';

import Details from './details/Details.connector';
import Summary from './summary/Summary.connector';
import Progress from './progress/Progress.connector';
import {
  fetchUnauthorizedProductsOrLocations,
  getStepTwoDisableContinue,
  resetSupplierAuthWizardData,
  setHasUnsavedChanges,
} from '../store/createNewSupplierAuthSlice';
import SelectProductStep from './select-product/SelectProductStep';

const newSupplierAuthSteps = [
  {
    component: <Details />,
    disabled: store => {
      const {
        inventoryOwner,
        params: {
          authorizationNumber,
          authorizationType,
          authorizedVolume,
          endDate,
          renewalVolume,
          supplierIdName,
        },
        viewById,
      } = store.loadingManagement.createNewSupplierAuth;
      const volumeRequired = authorizationType !== 'UNLIMITED' && authorizationType !== 'LIMITED';

      const validAuthNumber = R.cond([
        [R.isEmpty, R.F],
        [value => !isNumber(value), R.F],
        [value => isLessThan(value, 3), R.F],
        [value => !isLessThan(value, 6), R.F],
        [R.T, R.T],
      ])(authorizationNumber);

      return (
        !authorizationNumber ||
        !validAuthNumber ||
        !viewById ||
        !inventoryOwner.dataCompanyId ||
        !endDate ||
        isPast(parseISO(endDate)) ||
        !authorizationType ||
        !supplierIdName ||
        (volumeRequired && !renewalVolume) ||
        (authorizationType !== 'UNLIMITED' && !authorizedVolume)
      );
    },
    goNext: async (dispatch, setCurrentStepIdx) => {
      const result = await dispatch(fetchUnauthorizedProductsOrLocations());
      if (result === 'cached') {
        setCurrentStepIdx(1);
      }
    },
    id: 1,
    loading: R.F,
    rightLabel: 'Continue',
    showSpinner: store => store.loadingManagement.createNewSupplierAuth.unauthorizedListPending,
    stepLabel: R.always('Setup'),
  },
  {
    component: <SelectProductStep />,
    disabled: getStepTwoDisableContinue,
    goBack: R.F,
    goNext: (_, setCurrentStepIdx) => setCurrentStepIdx(2),
    id: 2,
    leftLabel: 'Back',
    loading: R.F,
    rightLabel: 'Continue',
    // TODO: replace with valid selector
    showSpinner: R.F,
    stepLabel: store => {
      const { authorizationBy } = store.loadingManagement.createNewSupplierAuth;
      return authorizationBy === 'location' ? 'Products' : 'Locations';
    },
  },
  {
    component: <Summary />,
    disabled: R.F,
    goBack: (_, setCurrentStepIdx) => !setCurrentStepIdx(1),
    goNext: (dispatch, setCurrentStepIdx) => {
      dispatch(setHasUnsavedChanges(false));
      setCurrentStepIdx(3);
    },
    id: 3,
    leftLabel: 'Back',
    loading: R.F,
    rightLabel: 'Submit',
    // TODO: replace with valid selector
    showSpinner: R.F,
    stepLabel: R.always('Summary'),
  },
  {
    component: <Progress />,
    disabled: R.F,
    goBack: (dispatchEvent, setCurrentStepIdx) => {
      dispatchEvent(resetSupplierAuthWizardData());
      setCurrentStepIdx(0);
      return true;
    },
    goNext: () => {},
    id: 4,
    leftLabel: 'Create New',
    loading: R.F,
    rightLabel: 'Done',
    // TODO: replace with valid selector
    showSpinner: R.F,
    stepLabel: R.always('Progress'),
  },
];

export default newSupplierAuthSteps;
